import React from "react";

import { ModalTypes } from "constants/navigation";

import { EditNominationModal } from "./Modal";

export function Adapter(props) {
  const { hash } = props;
  const hashParams = hash[ModalTypes.EditNomination] || null;
  const [nominationId, options] = JSON.parse(hashParams);
  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  return (
    <EditNominationModal
      nominationId={nominationId}
      options={options}
      returnTo={decodedReturnTo}
    />
  );
}
